export const MODULE_NAME = 'report';
export const ACCESS_NAME = 'Report';
